import dayjs from 'dayjs'
import { AuthType } from '../shared/enum'
import { setGlobalLoadingFx } from '../store/App/event'

export const localesDayjs: any = {
  ru: () => import('dayjs/locale/ru'),
  en: () => import('dayjs/locale/en'),
  hi: () => import('dayjs/locale/hi'),
  vi: () => import('dayjs/locale/vi'),
  fr: () => import('dayjs/locale/fr'),
  ar: () => import('dayjs/locale/ar'),
  ja: () => import('dayjs/locale/ja'),
  ko: () => import('dayjs/locale/ko'),
  es: () => import('dayjs/locale/es'),
}

export const changeLocaleDayjs = async (code: string) => {
  const getLocale = localesDayjs[code] || localesDayjs.en
  const locale = await getLocale()
  dayjs.locale(code)
  return locale
}

export const openUrl = (url: string) => {
  setGlobalLoadingFx(true)
  const form = document.createElement('form')
  form.setAttribute('method', 'GET')
  form.setAttribute('action', url)
  document.body.appendChild(form)
  form.submit()
}

export const getAuthType = (type: AuthType): string => {
  switch (type) {
    case AuthType.PASSWORD:
      return 'password'
    case AuthType.SMS:
      return 'sms'
    case AuthType.TELEGRAM:
      return 'telegram'
    case AuthType.WHATSAPP:
      return 'whatsapp'
    case AuthType.ADMIN:
      return 'admin'
    case AuthType.ANY:
    default:
      return 'unknow'
  }
}

export const IS_SAFARI = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor)
